// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FSyW","newExpiryDate":"styles_newExpiryDate__-thRC","footer":"styles_footer__1QVUQ"};